import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/relatorios/controle-saldos/ControleSaldosApiClient'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.RELATORIOS.CONTROLE_SALDOS.BUSCAR_ATAS](context, objParam) {
		const { data } = await api.buscarAtas(objParam)
		return data
	},
	async [actionTypes.RELATORIOS.CONTROLE_SALDOS.BUSCAR_ORGAOS](context, idAta) {
		const { data } = await api.buscarOrgaos(idAta)
		return data
	},
	async [actionTypes.RELATORIOS.CONTROLE_SALDOS.GERAR_RELATORIO](context, objParam) {
		const response = await api.gerarRelatorioControleSaldo(objParam)

		if (response.data.byteLength === 0) return 0

		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
